export default __webpack_public_path__ + "static/media/DancingScript-Bold.57bdbb73.ttf";